import HTTP from '../HTTP';

export default {
    getApplications () {
        return HTTP.get('/applications');
    },
    save (data) {
        return HTTP.post('/applications', data);
    },

    getApplicationLinks () {
        return HTTP.get('applications/link');
    },
    saveApplicationLink (data) {
        return HTTP.post('applications/link', data);
    },
    updateApplicationLink (composition_id, link_id, applications) {
        return HTTP.put(`/applications/link/${link_id}`, {
            composition_id,
            applications
        });
    },
    saveOrder(credentials) {
        return HTTP.put(`/applications/${credentials.materialId}/move`, credentials);
    },
    removeApplication(applicationId) {
        return HTTP.delete(`/applications/${applicationId}`);
    },
    removeApplicationLink(applicationId) {
        return HTTP.delete(`/applications/link/${applicationId}`);
    },
    changeVisibility(data) {
        return HTTP.put('/applications/hide', data);
    }
};